/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Segment_Unknown_DurationInputs */



/**
* | output |
* | --- |
* | "Media duration is unavailable, so the whole video will be exported" |
*
* @param {Video_Export_Segment_Unknown_DurationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_segment_unknown_duration = /** @type {((inputs?: Video_Export_Segment_Unknown_DurationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Segment_Unknown_DurationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("La durée du média n'étant pas disponible, la vidéo entière sera exportée.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Mediendauer ist nicht verfügbar, daher wird das gesamte Video exportiert.")
	if (locale === "it") return /** @type {LocalizedString} */ ("La durata del file multimediale non è disponibile, quindi l'intero video verrà esportato.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Информация о продолжительности медиафайла недоступна, поэтому будет экспортировано всё видео целиком.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se dispone de la duración del vídeo, por lo que se exportará el vídeo completo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("由于无法获取媒体时长，因此将导出整个视频。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディアの再生時間が不明なため、動画全体がエクスポートされます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मीडिया की अवधि उपलब्ध नहीं है, इसलिए पूरा वीडियो निर्यात किया जाएगा।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A duração da mídia não está disponível, portanto o vídeo inteiro será exportado.")
	return /** @type {LocalizedString} */ ("Media duration is unavailable, so the whole video will be exported")
});